import { defineMessages } from 'react-intl';
export default defineMessages({
  description: {
    id: 'description',
    defaultMessage: 'You may still proceed with the form filling by clicking on \'Next\' button again, but will not be able to submit the form unless required fields are filled',
  },
});



// WEBPACK FOOTER //
// ./app/components/Validation/messages.js